import { submitHubspotForm } from './hubspot'
import type { HubspotFormData } from './types'
import type { UserDetails } from 'types'
import { SUPPLIER_DISCLAIMER_HUBSPOT_FORM_ID } from './constants'

export function submitSupplierDisclaimerForm(user: UserDetails) {
  const formData: HubspotFormData = [
    // Fields necessary to associate the form submission with a user.
    {
      name: 'firstname',
      value: user.givenName,
    },
    {
      name: 'lastname',
      value: user.familyName,
    },
    {
      name: 'email',
      value: user.email,
    },
    {
      name: 'company',
      value: user.organisation,
    },
  ]

  return submitHubspotForm({
    id: SUPPLIER_DISCLAIMER_HUBSPOT_FORM_ID,
    data: formData,
  })
}
